import type { TextI } from "tweenly"
import AbstractContainer from "./AbstractContainer"

interface Props {
    object: TextI
    isHiding: boolean
    isLocking: boolean
    isRootTicker: boolean
    canvasScaleCoef: number
    borderCoef: number
    handleSelectObject: (
        event: React.MouseEvent,
        objectId: string,
        animationIds: string[],
        multiSelectKey: boolean
    ) => void
}

const TextContainer = ({
    object,
    isHiding,
    isLocking,
    isRootTicker,
    canvasScaleCoef,
    borderCoef,
    handleSelectObject,
}: Props) => {
    return (
        <AbstractContainer
            object={object}
            isHiding={isHiding}
            isLocking={isLocking}
            isRootTicker={isRootTicker}
            canvasScaleCoef={canvasScaleCoef}
            borderCoef={borderCoef}
            handleSelectObject={handleSelectObject}
            className={"text-container"}
            visibility={object.isHidden || isHiding ? "hidden" : "visible"}
            children={(object as TextI).text}
        />
    )
}

export default TextContainer
